export const PSD_IMPORT_SOURCES = {
  FILE_BROWSER: 'file-browser'
}